import './IconButton.scss'
import type { ComponentProps, ReactNode } from 'react'
import { clx } from '../clx'
import { Tooltip } from '../Tooltip'

export interface IconButtonProps extends Omit<ComponentProps<'button'>, 'children' | 'aria-label'> {
  /** Accessible name. Required: an icon alone is not a name. */
  label: string
  icon: ReactNode
  variant?: 'ghost' | 'secondary' | 'danger'
  size?: 'sm' | 'md'
  /** Show the label as a tooltip on hover/focus. Default true. */
  hasTooltip?: boolean
}

export function IconButton({
  label,
  icon,
  variant = 'ghost',
  size = 'md',
  hasTooltip = true,
  className,
  type = 'button',
  ref,
  ...rest
}: IconButtonProps) {
  const button = (
    <button
      ref={ref}
      type={type}
      aria-label={label}
      {...rest}
      className={clx(
        'icon-button',
        `icon-button--as-${variant}`,
        size !== 'md' && `icon-button--is-${size}`,
        className
      )}
    >
      <span className="icon-button__icon" aria-hidden="true">
        {icon}
      </span>
    </button>
  )
  return hasTooltip ? <Tooltip content={label}>{button}</Tooltip> : button
}
